const backupMenu = [
  {
    title: 'Dashboard',
    id: 'dashboard',
    url: '/',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Dashboard')
  },
  {
    title: 'Order',
    id: 'order',
    url: '/order',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Order')
  },
  {
    title: 'AWB Tracking',
    id: 'awb-tracking',
    url: '/tracking',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Tracking')
  },
  {
    title: 'Partner',
    id: 'partner',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Partner'),
    submenu: [
      {
        title: 'All Partners',
        url: '/partner/list'
      },
      {
        title: 'User',
        url: '/partner/user'
      },
      {
        title: 'Driver',
        url: '/partner/driver'
      },
      {
        title: 'Dropoff Agent',
        url: '/partner/dropoff'
      }
    ]
  },
  {
    title: 'Delivery',
    id: 'delivery',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Delivery'),
    submenu: [
      {
        title: 'Cost Mapping',
        url: '/delivery/cost-mapping'
      },
      {
        title: 'Package',
        url: '/delivery/package'
      }
    ]
  },
  {
    title: 'Master Data',
    id: 'master-data',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Data'),
    submenu: [
      {
        title: 'City',
        url: '/master-data/city'
      },
      {
        title: 'Payment Method',
        url: '/master-data/payment-method'
      },
      {
        title: 'Goods Category',
        url: '/master-data/goods-category'
      },
      {
        title: 'Bank Code',
        url: '/master-data/bank-code'
      }
    ]
  },
  {
    title: 'Pertashop',
    id: 'pertashop',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/GasStation'),
    submenu: [
      {
        title: 'Local Agent',
        url: '/pertashop/local-agent'
      }
    ]
  },
  {
    title: 'Role',
    id: 'role',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/UserSetting'),
    submenu: [
      {
        title: 'Role Management',
        url: '/role/role-management'
      },
      {
        title: 'Permission List',
        url: '/role/permission'
      },
      {
        title: 'Role List',
        url: '/role/list'
      }
    ]
  },
  {
    title: 'Admin',
    id: 'admin',
    url: '/admin',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/UserSetting')
  }
]

const internalMenu = [
  {
    title: 'Dashboard',
    id: 'dashboard',
    url: '/dashboard',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Dashboard')
  },
  {
    title: 'AI Agent',
    id: 'ai-agent',
    url: '/ai-agent',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/AIAgent')
  },
  {
    title: 'Cek AWB',
    id: 'awb-tracking',
    url: '/tracking',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/AwbTracking')
  },
  {
    title: 'Cek Ongkir',
    id: 'ongkir',
    url: '/ongkir',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Calculator')
  },
  {
    title: 'Pesanan',
    id: 'order',
    url: '/order',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Order')
  },
  {
    title: 'Pengguna',
    id: 'user',
    url: '/admin',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/User')
  },
  {
    title: 'Laporan Biaya',
    id: 'report',
    url: '/report',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Transaction')
  },
  {
    title: 'Daftar Alamat',
    id: 'Address',
    url: '/address',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Place')
  },
  {
    title: 'Voucher',
    id: 'voucher',
    url: '/voucher',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Discount')
  },
  {
    title: 'Open API',
    id: 'open-api',
    url: '/open-api',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Integration')
  }
]

const externalMenu = [
  {
    title: 'Dashboard',
    id: 'dashboard',
    url: '/',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Dashboard')
  },
  {
    title: 'Cek AWB',
    id: 'awb-tracking',
    url: '/tracking',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/AwbTracking')
  },
  {
    title: 'Cek Ongkir',
    id: 'ongkir',
    url: '/ongkir',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Calculator')
  },
  {
    title: 'Pesanan',
    id: 'order',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Order'),
    submenu: [
      {
        title: 'Daftar Pesanan',
        url: '/order'
      },
      {
        title: 'Request Pickup',
        url: '/order/pickup'
      }
    ]
  },
  {
    title: 'Armada',
    id: 'armada',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Driver'),
    submenu: [
      {
        title: 'Daftar Armada',
        url: '/armada'
      },
      {
        title: 'Partner Armada',
        url: '/armada/partner'
      }
    ]
  },
  {
    title: 'Kurir',
    id: 'kurir',
    url: '/kurir',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Courier')
  },
  // {
  //   title: 'Partner',
  //   id: 'partner',
  //   active: false,
  //   url: '/partner',
  //   icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Courier')
  // },
  {
    title: 'Pengguna',
    id: 'user',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/User'),
    submenu: [
      {
        title: 'User List',
        url: '/user'
      },
      {
        title: 'User Role',
        url: '/user/role'
      }
    ]
  },
  {
    title: 'Hub/Drop Point',
    id: 'hub',
    url: '/hub',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Courier')
  },
  {
    title: 'Layanan',
    id: 'package',
    active: false,
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Price'),
    submenu: [
      {
        title: 'Layanan',
        url: '/package'
      },
      {
        title: 'Cost Mapping',
        url: '/package/cost-mapping'
      }
    ]
  },
  {
    title: 'Kategori Barang',
    id: 'goods',
    url: '/goods-category',
    icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Goods')
  }
  // {
  //   title: 'Master Data',
  //   id: 'master-data',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Data'),
  //   submenu: [
  //     {
  //       title: 'City',
  //       url: '/master-data/city'
  //     },
  //     {
  //       title: 'Payment Method',
  //       url: '/master-data/payment-method'
  //     },
  //     {
  //       title: 'Goods Category',
  //       url: '/master-data/goods-category'
  //     },
  //     {
  //       title: 'Bank Code',
  //       url: '/master-data/bank-code'
  //     }
  //   ]
  // },
  // {
  //   title: 'Pertashop',
  //   id: 'pertashop',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/GasStation'),
  //   submenu: [
  //     {
  //       title: 'Local Agent',
  //       url: '/pertashop/local-agent'
  //     }
  //   ]
  // },
  // {
  //   title: 'Role',
  //   id: 'role',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/UserSetting'),
  //   submenu: [
  //     {
  //       title: 'Role Management',
  //       url: '/role/role-management'
  //     },
  //     {
  //       title: 'Permission List',
  //       url: '/role/permission'
  //     },
  //     {
  //       title: 'Role List',
  //       url: '/role/list'
  //     }
  //   ]
  // },
  // {
  //   title: 'Admin',
  //   id: 'admin',
  //   url: '/admin',
  //   icon: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/UserSetting')
  // }
]

export { externalMenu, internalMenu }
